export default __webpack_public_path__ + "assets/webgl/complete-14.e6759875.jpg";